var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 183.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .card-1 {\n        fill: #295575;\n      }\n\n      .card-2 {\n        fill: #e2b64f;\n      }\n\n      .card-3 {\n        fill: #28a3da;\n      }\n\n      .card-4 {\n        fill: #fccb56;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "card-3",
    width: 280,
    height: 183.45,
    rx: 34.13,
    ry: 34.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "card-4",
    x: 19.31,
    y: 24.14,
    width: 57.93,
    height: 48.28,
    rx: 17.07,
    ry: 17.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "card-4",
    cx: 246.21,
    cy: 149.66,
    r: 14.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M217.24,67.59c-2.67,0-4.83-2.17-4.82-4.83,0-1.41.62-2.75,1.7-3.67,3.3-2.3,4.12-6.84,1.82-10.14-.49-.71-1.11-1.33-1.82-1.82-2.03-1.73-2.27-4.78-.54-6.81s4.78-2.27,6.81-.54c7.36,5.74,8.68,16.35,2.94,23.71-.86,1.1-1.85,2.09-2.94,2.94-.88.75-1.99,1.16-3.15,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M231.72,82.07c-2.67,0-4.83-2.16-4.83-4.83,0-1.23.47-2.41,1.31-3.3,11.13-11.66,11.13-30.01,0-41.67-1.88-1.9-1.86-4.95.04-6.83,1.9-1.88,4.95-1.86,6.83.04.06.06.12.12.18.19,14.62,15.37,14.62,39.51,0,54.88-.91.97-2.19,1.52-3.52,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M246.21,91.72c-2.67,0-4.83-2.16-4.83-4.82,0-1.29.51-2.52,1.42-3.43,16.77-15.89,17.49-42.37,1.6-59.14-.52-.55-1.05-1.08-1.6-1.6-1.89-1.88-1.9-4.94-.01-6.83,1.88-1.89,4.94-1.9,6.83-.01,20.55,19.66,21.28,52.26,1.62,72.82-.53.55-1.07,1.09-1.62,1.62-.91.9-2.13,1.41-3.41,1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M48.28,164.14h-24.14c-2.67,0-4.83-2.16-4.83-4.83s2.16-4.83,4.83-4.83h24.14c2.67,0,4.83,2.16,4.83,4.83s-2.16,4.83-4.83,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M62.76,115.86h-28.97c-2.67,0-4.83-2.16-4.83-4.83s2.16-4.83,4.83-4.83h28.97c2.67,0,4.83,2.16,4.83,4.83s-2.16,4.83-4.83,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M111.03,115.86h-28.97c-2.67,0-4.83-2.16-4.83-4.83s2.16-4.83,4.83-4.83h28.97c2.67,0,4.83,2.16,4.83,4.83s-2.16,4.83-4.83,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M159.31,115.86h-28.97c-2.67,0-4.83-2.16-4.83-4.83s2.16-4.83,4.83-4.83h28.97c2.67,0,4.83,2.16,4.83,4.83s-2.16,4.83-4.83,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M207.59,115.86h-28.97c-2.67,0-4.83-2.16-4.83-4.83s2.16-4.83,4.83-4.83h28.97c2.67,0,4.83,2.16,4.83,4.83s-2.16,4.83-4.83,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M91.72,164.14h-24.14c-2.67,0-4.83-2.16-4.83-4.83s2.16-4.83,4.83-4.83h24.14c2.67,0,4.83,2.16,4.83,4.83s-2.16,4.83-4.83,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M106.21,135.17h-19.31c-2.67,0-4.83-2.16-4.83-4.83s2.16-4.83,4.83-4.83h19.31c2.67,0,4.83,2.16,4.83,4.83s-2.16,4.83-4.83,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M130.34,135.17h-4.83c-2.67,0-4.83-2.16-4.83-4.83s2.16-4.83,4.83-4.83h4.83c2.67,0,4.83,2.16,4.83,4.83s-2.16,4.83-4.83,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "card-1",
    d: "M154.48,135.17h-4.83c-2.67,0-4.83-2.16-4.83-4.83s2.16-4.83,4.83-4.83h4.83c2.67,0,4.83,2.16,4.83,4.83s-2.16,4.83-4.83,4.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "card-2",
    d: "M43.45,72.41v-14.48h33.79v-9.66h-14.48v-24.14h-9.66v24.14h-9.66v-24.14h-9.66v24.14h-14.48v9.66h14.48v14.48h9.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.5cb646e7fbf45636f565470bb5b6a607.svg";
export { ForwardRef as ReactComponent };